<template>
    <div class="join">
        <div class="impression">
            <div class="title"></div>
            <div class="scroll-wrapper">
                <swiper :options="swiperOption" class="swiper" ref="swiper">
                    <swiper-slide v-for="(item, index) in imgList" :key="index">
                        <img :src="url" v-for="(url, j) in item" :key="j" />
                    </swiper-slide>
                </swiper>
            </div>
        </div>
        <div class="portal">
            <div class="portal-wrapper">
                <div class="weixin">
                    <div class="qrcode"></div>
                    <div class="txt">
                        <p>更多实时动态与招聘信息</p>
                        <p>请关注我们</p>
                        <p>人力资源部电话：010-64701502</p>
                    </div>
                </div>
                <a href="https://www.lagou.com/gongsi/j36162.html" class="job" target="_blank"></a>
            </div>
        </div>
    </div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    // require styles
	import "swiper/dist/css/swiper.css";
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    
    const YOUPAI = 'https://appd.knowbox.cn/ss/activity/knowbox-web/img/';

	@Component({
        components: {
            swiper,
            swiperSlide 
        }
    })
	export default class Join extends Vue {
        swiperOption = {
            slidesPerView: 'auto',
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true 
            },
            allowClick: false,
            preventClicks: true,
            preventClicksPropagation: true
        }

        imgList = [
            [
                `${YOUPAI}join/screen-1-col-11.png`,
                `${YOUPAI}join/screen-1-col-12.png`
            ],
            [
                `${YOUPAI}join/screen-1-col-21.png`,
                `${YOUPAI}join/screen-1-col-22.png`
            ],
            [
                `${YOUPAI}join/screen-1-col-31.png`,
                `${YOUPAI}join/screen-1-col-32.png`,
                `${YOUPAI}join/screen-1-col-33.png`
            ],
            [
                `${YOUPAI}join/screen-1-col-41.png`,
            ],
            [
                `${YOUPAI}join/screen-1-col-51.png`,
                `${YOUPAI}join/screen-1-col-52.png`
            ],
            // [
            //     `${YOUPAI}join/screen-1-col-61.png`,
            //     `${YOUPAI}join/screen-1-col-62.png`
            // ]
        ];

        get swiper() {
			return this.$refs.swiper.swiper;
        }
    }
</script>
<style lang="scss">
    .join {
        background: #F8F8F8;
        padding-top: 100px;
        box-sizing: border-box;
        .impression {
            padding: 84px 0 42px;
            box-sizing: border-box;
            .title {
                width: 100%;
                height: 96px;
                margin-bottom: 32px;
                padding: 0 100px;
                &::before {
                    width: 325px;
                    height: 96px;
                    display: block;
                    content: '';
                    background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/join/impressionx2.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
            .swiper {
                .swiper-slide {
                    width: 304px;
                    > img {
                        max-width: 304px;
                        max-height: 473px;
                    }
                }
            }
        }
        .portal {
            width: 100%;
            height: 530px;
            background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/join/portal.png) center center no-repeat;
            position: relative;
            &-wrapper {
                padding: 144px 100px 0;
                .weixin {
                    display: flex;
                    .qrcode {
                        width: 112px;
                        height: 112px;
                        background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/join/qrcode.png) no-repeat;
                        background-size: 100%;
                    }
                    .txt {
                        color: #fff;
                        font-size: 18px;
                        line-height: 34px;
                        margin: 10px 0 0 15px;
                        font-family: PingFangSC-light;
                    }
                }
                .job {
                    width: 245px;
                    height: 84px;
                    display: inline-block;
                    background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/join/jobx2.png) no-repeat;
                    background-size: 100% 100%;
                    margin-top: 75px;
                    &:hover {
                        background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/join/job-activex2.png);
                    }
                }
            }
        }
    }
</style>